import React from 'react';
import { useParams } from 'react-router-dom';
import { useSearchParam } from 'react-use';

import AuthByCodePage from '../AuthByCode';

export default function LoginCodeAuthPage() {
    const { code } = useParams();
    const redirectTo = useSearchParam('redirect_to');

    return <AuthByCodePage code={code} redirectTo={redirectTo} />;
}
